// extracted by mini-css-extract-plugin
module.exports = {"hero":"style-module--hero--1-5tM","heroImage":"style-module--heroImage--3Vi1W","heroContainer":"style-module--heroContainer--2vgje","gameCards":"style-module--gameCards--BCrh-"};